import { render, staticRenderFns } from "./WidgetWrap.vue?vue&type=template&id=68a97eb5&scoped=true&"
import script from "./WidgetWrap.vue?vue&type=script&lang=js&"
export * from "./WidgetWrap.vue?vue&type=script&lang=js&"
import style0 from "./WidgetWrap.vue?vue&type=style&index=0&id=68a97eb5&prod&scoped=true&lang=scss&"
import style1 from "./WidgetWrap.vue?vue&type=style&index=1&id=68a97eb5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a97eb5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VIcon,VRow,VTooltip})
